import DropPanel from "./DropPanel";
import Delegate from "../../Delegate";

/**
 * Fullscreen drop panel
 */
export default class FSDropPanel extends DropPanel {

	private _wndResizeBind: EventListenerObject;
	private _resizeTimeout: number;

	_render()
	{
		this._Width = document.body.offsetWidth;
		this._Height = document.body.offsetHeight;
		super._render();
	}

	_initFields(settings: object)
	{
		super._initFields(settings);
		this._AutoDestroy = true;
		this._CloseOnWindowResize = false;
	}


	_bindEvents()
	{
		if (!this._isBind)
		{
			super._bindEvents();
			window.addEventListener('resize', this._wndResizeBind = this._onWndResize.bind(this), false);
		}
	}

	_unBindEvents()
	{
		window.removeEventListener('resize', this._wndResizeBind);
		super._unBindEvents();
	}

	_onWndResize()
	{
		if (this._resizeTimeout)
			clearTimeout(this._resizeTimeout);
		this._resizeTimeout = <any>setTimeout(() =>
		{
			this.setWidth(document.body.offsetWidth);
			this.setHeight(document.body.offsetHeight);
		}, 50);
	}
}